import React, { useCallback, useState } from "react";
import Select from "react-select";

function MultiSelect({
  classname,
  labelclassname,
  name,
  placeholder,
  onChange,
  formik,
  label,
  Options,
  customClass,
  isRequired,
  width,
  FixPosition = false,
  PortalTarget = false
}) {
  const options = Options;

  const handleChange = (selectedOptions) => {
    // Extracting values from the selected options array
    const selectedValues = selectedOptions.map(option => option.value);
    formik.handleChange({
      target: {
        value: selectedValues, // Setting selected values as an array
        name: name,
      },
    });
  };

  const styles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #e5e5e5",
      outline: "none",
      borderRadius: "10px",
      padding: "1px 0",
      color: "#000",
      textAlign: "left",
      fontWeight: "500",
      width: "100%",
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "8px 12px",
      fontSize: "12px",
      [`@media (min-width: 640px)`]: {
        fontSize: "12px",
      },
      [`@media (min-width: 768px)`]: {
        fontSize: "12px",
      },
      [`@media (min-width: 1024px)`]: {
        fontSize: "12px",
      },
      [`@media (min-width: 1536px)`]: {
        fontSize: "14px",
      },
      color: state.isSelected ? "#fff" : "#000",
      backgroundColor: state.isSelected ? "#2563EB" : "#fff",
      ":hover": {
        color: "#fff",
        backgroundColor: "#60A5FA",
      },
    }),
  };
  const selectedOptions = options?.filter(option => formik?.values?.[name]?.includes(option.value)) || [];
  const blacklistedSelected = selectedOptions.filter(option => Boolean(option?.isBlacklisted || option?.blacklisted || option?.isBlacklist || option?.is_blacklisted));

  return (
    <>
      <div className={`${width} relative lg:px-6 py-2`}>
        <label className={`${labelclassname} text-xs 2xl:text-sm`}>
          {label}
          {isRequired ? <span className="text-red-500"> *</span> : ""}
        </label>
        <div className="mt-2">
          <Select
            options={options}
            isMulti={true}
            value={selectedOptions}
            styles={styles}
            className={`${classname} text-xs capitalize 2xl:text-sm mt-2 font-medium`}
            name={name}
            onChange={onChange || handleChange}
            placeholder={placeholder}
            closeMenuOnSelect={false}
            menuPosition={FixPosition == true ? "fixed" : "fixed"}
            menuPortalTarget={typeof document !== "undefined" ? document.body : null}
            formatOptionLabel={(option) => (
              <div className="flex items-center justify-between gap-2">
                <span>{option.label}</span>
                {Boolean(
                  option?.isBlacklisted ||
                  option?.blacklisted ||
                  option?.isBlacklist ||
                  option?.is_blacklisted
                ) && (
                    <span className="text-[10px] px-1.5 py-0.5 rounded font-bold bg-rose-100 text-rose-700 border border-rose-200">
                      Blacklisted
                    </span>
                  )}
              </div>
            )}
          />
        </div>
        {blacklistedSelected.length > 0 && (
          <div className="mt-1 flex items-center gap-1.5 text-xs text-red-500 font-medium">
            <svg
              className="w-3.5 h-3.5 shrink-0 text-red-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
            <span>
              {blacklistedSelected.length === 1
                ? `${blacklistedSelected[0].label || "This supplier"} is blacklisted by the company`
                : `${blacklistedSelected.map((s) => s.label).join(", ")} are blacklisted by the company`}
            </span>
          </div>
        )}
        {formik?.errors[name] ? (
          <span className="text-xs font-semibold text-red-500 ">
            {formik.errors[name]}
          </span>
        ) : null}
      </div>
    </>
  );
}

export default MultiSelect;


export function MultiSelectTwo({
  classname,
  labelclassname,
  name,
  placeholder,
  onChange,
  formik,
  label,
  Options,
  customClass,
  isRequired,
  width,
  handleClick = () => { },
  debounceTime = 900,
  setSearch
}) {
  const options = Options;

  const [loading, setLoading] = useState(false);

  // Debounce function to limit API calls
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  // Handle dynamic search
  const handleInputChange = useCallback(
    debounce(async (inputValue) => {
      if (inputValue) {
        if (inputValue.length >= 3) {
          setLoading(true);
          setSearch(inputValue);
          setLoading(false);
        }
      } else if (inputValue.length == 0) {
        setLoading(true);
        setSearch(inputValue);
        setLoading(false);

      }
    }, debounceTime),
    []
  );

  const handleChange = (selectedOptions) => {
    // Extracting values from the selected options array
    const selectedValues = selectedOptions.map(option => option.value);
    formik.handleChange({
      target: {
        value: selectedValues, // Setting selected values as an array
        name: name,
      },
    });
  };

  const selectedOptions = options?.filter(option => formik?.values?.[name]?.includes(option.value)) || [];
  const blacklistedSelected = selectedOptions.filter(option => Boolean(option?.isBlacklisted || option?.blacklisted || option?.isBlacklist || option?.is_blacklisted));

  const styles = {
    control: (provided) => ({
      ...provided,

      border: "1px solid #e5e5e5",
      outline: "none",
      borderRadius: "10px",
      padding: "1px 0",
      color: "#000",
      textAlign: "left",
      // fontSize:'13px',
      fontWeight: "500",
      width: "100%",
      // zIndex:0
    }),
    // menuPortal: (provided) => ({
    //   ...provided,
    //   zIndex: 9999,
    // }),
    // menu: (provided) => ({
    //   ...provided,
    //   zIndex: 9999,
    // }),

    option: (provided, state) => ({
      ...provided,
      padding: "8px 12px", // Default padding
      fontSize: "12px", // Default font size for small screens
      [`@media (min-width: 640px)`]: {
        fontSize: "12px", // sm breakpoint (Tailwind sm: text-sm)
      },
      [`@media (min-width: 768px)`]: {
        fontSize: "12px", // md breakpoint (Tailwind md: text-base)
      },
      [`@media (min-width: 1024px)`]: {
        fontSize: "12px", // lg breakpoint (Tailwind lg: text-lg)
      },
      [`@media (min-width: 1536px)`]: {
        fontSize: "14px", // lg breakpoint (Tailwind lg: text-lg)
      },
      color: state.isSelected ? "#fff" : "#000", // Custom colors for selected options
      backgroundColor: state.isSelected ? "#2563EB" : "#fff", // Custom background color for selected option
      ":hover": {
        color: "#fff",
        backgroundColor: "#60A5FA", // Hover state color
      },
    }),
  };
  return (
    <>
      <div className={`${width} relative sm:px-2 lg:px-6 py-2`}>
        <div className=" w-full flex gap-2 justify-start items-start">
          <label className={`${labelclassname} text-xs 2xl:text-sm w-[90%]`}>
            {label}
            {isRequired ? <span className="text-red-500"> *</span> : ""}
          </label>
          <button onClick={handleClick} type="button" className="w-6  text-center h-6 cursor-pointer bg-[#048178] flex justify-center items-center border border-solid border-white  text-white font-semibold rounded-lg " > + </button>

        </div>
        <div className="mt-2">
          <Select
            options={options}
            isMulti={true}
            value={selectedOptions}
            styles={styles}
            className={`${classname} text-xs capitalize 2xl:text-sm font-medium`}
            name={name}
            onChange={onChange || handleChange}
            placeholder={placeholder}
            closeMenuOnSelect={false}
            onInputChange={handleInputChange}
            isLoading={loading}
            menuPortalTarget={typeof document !== "undefined" ? document.body : null}
            menuPosition="absolute"
            menuPlacement="auto"
            formatOptionLabel={(option) => (
              <div className="flex items-center justify-between gap-2">
                <span>{option.label}</span>
                {Boolean(
                  option?.isBlacklisted ||
                  option?.blacklisted ||
                  option?.isBlacklist ||
                  option?.is_blacklisted
                ) && (
                    <span className="text-[10px] px-1.5 py-0.5 rounded font-bold bg-rose-100 text-rose-700 border border-rose-200">
                      Blacklisted
                    </span>
                  )}
              </div>
            )}
          // menuPosition={FixPosition == true ? "fixed" : "absolute"}
          // menuPortalTarget={PortalTarget == true ? document.body : ""}
          />
        </div>
        {blacklistedSelected.length > 0 && (
          <div className="mt-1 flex items-center gap-1.5 text-xs text-red-500 font-medium">
            <svg
              className="w-3.5 h-3.5 shrink-0 text-red-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
            <span>
              {blacklistedSelected.length === 1
                ? `${blacklistedSelected[0].label || "This supplier"} is blacklisted by company`
                : `${blacklistedSelected.map((s) => s.label).join(", ")} are blacklisted by company`}
            </span>
          </div>
        )}
        {formik.errors[name] ? (
          <span className="text-xs font-semibold text-red-500 ">
            {formik.errors[name]}
          </span>
        ) : null}
      </div>
    </>
  );
}

